import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .factory('notificationCarouselService', notificationCarouselService);

    function notificationCarouselService(storageService, MarketsMessages) {
        var notifications = [];
        var closedNotifications =
            storageService.fetchFromLocal('closedNotifications') || [];

        return {
            init: init,
            notifications: notifications,
            closeNotification: closeNotification
        };

        function init() {
            notifications.splice(0, notifications.length);
            MarketsMessages.query({}, function (res) {
                filterAndSave(res);
            });
        }

        function filterAndSave(notFiltered) {
            notFiltered.forEach(function (notification) {
                var isClosed = false;

                var closedOne: any = closedNotifications.find(
                    (item) => item.id === notification.id
                );
                if (closedOne !== undefined) {
                    isClosed =
                        Date.parse(closedOne.changedAt) ==
                        Date.parse(notification.changedAt);
                    if (!isClosed) {
                        var deleteIndex = closedNotifications.findIndex(
                            (item) => item.id === closedOne.id
                        );
                        if (deleteIndex >= 0) {
                            closedNotifications.splice(deleteIndex, 1);
                        }
                    }
                }

                if (!isClosed) {
                    addNotification(notification);
                }
            });
        }

        function addNotification(notification) {
            notifications.push(notification);
        }

        // Push has been disabled temporarily as of BTCPKP-9138
        function updateNotification(notification) {
            var index = notifications.findIndex(
                (item) => item.id === notification.id
            );
            if (index !== -1) {
                notifications[index] = notification;
            } else {
                addNotification(notification);
            }
        }

        function closeNotification(index) {
            var closedOnes = removeNotificationByIndex(index);

            closedNotifications.push(buildClosedNotification(closedOnes[0]));
            storageService.storeToLocal(
                'closedNotifications',
                closedNotifications
            );
        }

        function removeNotificationByIndex(index) {
            return notifications.splice(index, 1);
        }

        // Push has been disabled temporarily as of BTCPKP-9138
        function removeNotificationByObject(notification) {
            var index = notifications.find(
                (item) => item.id === notification.id
            );
            removeNotificationByIndex(index);
        }

        function buildClosedNotification(notification) {
            return {
                id: notification.id,
                changedAt: notification.changedAt,
                closedAt: Date.now()
            };
        }
    }
})();
